<template>
  <div class="TimeM">
    <ul style="margin: 0 auto; text-align: center">
      <span class="circle"></span>
      <span class="circle"></span>
      <span class="circle"></span>
    </ul>
    <ul style="margin: 0 auto; text-align: center; font-size: 13px">
      {{
        $t('component.TimeM.chooseTime')
      }}
    </ul>
    <ul class="dateContainer">
      <!-- style="margin-left: 15px" -->
      <span class="dataContainerFrom">{{ $t('component.TimeM.from') }}</span>
      <a-input
        v-model:value="beginDateInput"
        class="dateInput"
        style="border: 0; width: 38%"
        readOnly
      ></a-input>
      <a-date-picker placeholder="Select Time" @change="onBeginChange" />
      <span style="margin-left: 15px">{{ $t('component.TimeM.to') }}</span>
      <a-input
        v-model:value="endDateInput"
        class="dateInput"
        style="border: 0; width: 38%"
        readOnly
      ></a-input>
      <a-date-picker placeholder="Select Time" @change="onEndChange" />
    </ul>
    <ul class="btnContainer">
      <a-button type="primary" :loading="qloading" @click="queryEvent">{{
        $t('component.TimeM.query')
      }}</a-button>
      <a-button type="primary" :loading="eloading" @click="exportExcel">{{
        $t('component.TimeM.exportExcel')
      }}</a-button>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TimeM',
  data() {
    return {
      beginDateInput: '',
      endDateInput: '',
      qloading: false,
      eloading: false
    };
  },
  props: {},
  methods: {
    onBeginChange(date, dateString) {
      this.beginDateInput = dateString;
    },
    onEndChange(date, dateString) {
      this.endDateInput = dateString;
    },
    exportExcel() {
      let dataObj = {};
      dataObj.begin = this.beginDateInput;
      dataObj.end = this.endDateInput;
      this.$emit('exportExcel', dataObj);
    },
    queryEvent() {
      let dataObj = {};
      dataObj.begin = this.beginDateInput;
      dataObj.end = this.endDateInput;
      this.$emit('queryEvent', dataObj);
    },
    getCurrentData() {
      return this.$moment().format('YYYY-MM-DD');
      //return new Date().toLocaleDateString();
    }
  },
  created() {
    var today = this.getCurrentData();
    this.beginDateInput = today;
    this.endDateInput = today;
  }
};
</script>

<style scoped>
.TimeM {
  display: flex;
  flex-flow: column;
  background-color: #c6cbd1;

  border-radius: 8px;
  color: #3d4d6b;
}
.TimeM .circle {
  /* 设置圆点的宽、高、背景颜色，再设置圆点半径所占百分比 */
  width: 4px;
  height: 4px;
  background-color: #3d4d6b;
  border-radius: 50%;
  display: inline-block;
  margin-top: 8px;
  margin-right: 3px;
  margin-bottom: 8px;
}
.triangle {
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: black;
}
.dateContainer {
  display: flex;
  background: white;
  align-items: center;
  justify-content: center;
  width: 95%;
  border-radius: 4px;
  height: 38px;
  margin: 10px auto;
  padding: 5px;
}
.btnContainer {
  flex: 1;
  display: flex;
  justify-content: space-around;
  padding: 10px;
  align-items: center;
}
.btnContainer button:first-child {
  width: 45%;
  height: 38px;
  background: #2ca70e;
  border-color: #2ca70e;
}
.btnContainer button:last-child {
  width: 45%;
  height: 38px;
  background: #11254a;
  border-color: #11254a;
}
.dataContainerFrom {
  margin-left: 15px;
}

@media (max-width: 1240px) {
  .btnContainer {
    padding: 0 4px;
    margin-bottom: 10px;
  }

  .btnContainer button:first-child {
    width: 34%;
    height: 38px;
    padding: 0;
  }

  .btnContainer button:last-child {
    width: 64%;
    height: 38px;
    padding: 0 2px;
  }
}

@media (max-width: 470px) {
  .dataContainerFrom {
    margin-left: 6px;
  }
  .dateInput {
    padding-left: 4px;
    padding-right: 4px;
  }
}
</style>